<script>
  import Alert from "../Alerts/Alert.svelte";
  import { useLicenseData } from "../../hooks/license/useLicenseData.js";
  import { translate } from "../../i18n/i18next.js";

  const licenseData = useLicenseData()
</script>

{#if $licenseData?.status?.isInMaintenanceMode}
  <Alert type="error">
    <div>
      <div>
        {translate("frontend:components.licenseStatusAlert.messages.1")}
      </div>
      <div>
        {translate("frontend:components.licenseStatusAlert.messages.2")}
      </div>
    </div>
  </Alert>
{/if}
